// About Page Content

const aboutContent = {
  bio: `Krishi is a New York City based filmmaker. She released her first short film "Brink" in 2022, where it premiered at PyGotham Film Festival.

Despite no formal education in filmmaking, Krishi has learned her craft through a lifetime of wandering, picking up bits and pieces of the art form along the way. She started drawing at three. She captured her first footage at nine. She won her first writing contest at ten. For Krishi, telling stories across mediums has been the only constant in a life full of change.

She graduated from the University of Virginia with a double major in mathematics and English. Her pragmatism brought her to New York City in the fall of 2016. Although she came to begin a corporate career in finance, she left with a rekindled passion for art. She bought oil paints in Brooklyn and painted her way through her 20s.

In her early 30s, she now has too many stories to paint. Her focus is on filmmaking, a craft which allows her to share her world. Forever a student, Krishi spends most of her time reading materials borrowed from the New York Public Library for the Performing Arts, taking photos with her Canon AE-1 program in Hell's Kitchen and practicing the art of telling stories through making little films.`,

  featured_image: 'self',

  highlights: [
    'Filmmaker & Visual Artist',
    'NYC Based',
    'Mathematics & English, UVA',
    'Film Photography & Painting'
  ]
};

export default aboutContent;
